import {
  MATCHING_PATIENT_DETAILS_SUCCESS,
  MATCHING_PATIENT_DETAILS_FAILURE,
} from '../actions/types';

const initialState = null;

export default function matchingPatientDetailsReducer(
  state = initialState,
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case MATCHING_PATIENT_DETAILS_SUCCESS:
      return payload;
    case MATCHING_PATIENT_DETAILS_FAILURE:
      return false;

    default:
      return state;
  }
}
